import classNames from "classnames";
// React
import React from "react";
// Routing
import { Link } from 'react-router';
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./SideBar_Link.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class SideBar_Link extends React.Component {
    render() {
        return (React.createElement(Link, { to: this.props.url, activeClassName: styles.activeLink, className: classNames(styles.link, styles.clickableLink) }, this.props.text));
    }
}
